module.exports = __webpack_public_path__ + "static/media/vdo-benefit.210dd6db.png";